export default "__VITE_ASSET__BjhecVPb__"